import { IBookingUnavailableReason, IFormAddBookingItemRequest } from 'models/bookappointment';

export interface IManualBookingFormData {
	customerId?: string;
	dateOfTheAppointment?: string;
	startTimeOfTheAppointment?: string;
	appointmentNote?: string;
	frequency?: string;
	endsAt?: number; // 1 == Specific date
	endsAtDate?: string;
	bookingItems?: IFormAddBookingItemRequest[];
	cancellationBookingItems?: IFormAddBookingItemRequest[];
	currentService?: IFormAddBookingItemRequest; // For edit service
	bookingItemConflicts?: IBookingUnavailableReason[];
	lastTime?: string;
	totalPrice?: number;
	upcomingRecurringBookingItems?: IFormAddBookingItemRequest[];
	updateOnlySelectedItem?: boolean;
	enableNotifications?: boolean;
	// Drag and drop always true
	isEditModeEnabled?: boolean;

	isRecurringEvent?: boolean;
	isPaidOnline?: boolean;
}

export interface IBlockedTimeFormData {
	name?: string;
	resourceId?: string;
	note?: string;
	date?: string;
	startTime?: string;
	endTime?: string;
	isEditModeEnabled?: boolean;
}

export enum ManualBookingPeriods {
	DoesNotRepeat = 'does-not-repeat',
	Days = 'days',
	Weeks = 'weeks',
	Months = 'months',
	Daily = 'daily',
	Weekly = 'weekly',
	Monthly = 'monthly',
}

export interface IManualBookingFrequency {
	multiplier: number;
	period: ManualBookingPeriods;
}

export interface ICancelAppointmentScreenFormData {
	deleteAllUpcomingItems?: boolean;
	messageForCustomer?: string;
}
